/**
 * Cart drawer cross-sell — loads Shopify product recommendations below cart items.
 */
if (!customElements.get("cart-drawer-cross-sell")) {
  const recommendationCache = new Map();
  let lastRecommendationsMarkup = "";

  customElements.define(
    "cart-drawer-cross-sell",
    class CartDrawerCrossSell extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        const cachedMarkup =
          recommendationCache.get(url) || lastRecommendationsMarkup;

        if (cachedMarkup) {
          this.showRecommendations(cachedMarkup);
        }

        // Quantity changes and cart additions recreate this element. Reuse the
        // recommendations immediately when the source product has not changed.
        if (recommendationCache.has(url)) return;

        this.loadRecommendations();
      }

      showRecommendations(markup) {
        this.innerHTML = markup;
        this.hidden = false;
      }

      loadRecommendations() {
        const url = this.dataset.url;
        if (!url || this.dataset.loading === "true") return;

        this.dataset.loading = "true";

        fetch(url)
          .then((response) => (response.ok ? response.text() : Promise.reject()))
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html");
            const content = doc.querySelector("[data-cart-cross-sell]");

            if (content && content.innerHTML.trim().length) {
              const markup = content.outerHTML;
              recommendationCache.set(url, markup);
              lastRecommendationsMarkup = markup;
              this.showRecommendations(markup);
            } else {
              this.innerHTML = "";
              this.hidden = true;
            }
          })
          .catch(() => {
            // Keep already-rendered recommendations in place if a refresh
            // request fails, avoiding a visible layout jump.
            if (!this.innerHTML.trim()) {
              this.hidden = true;
            }
          })
          .finally(() => {
            this.dataset.loading = "false";
          });
      }
    }
  );
}
